import { render, staticRenderFns } from "./ChangeOfClassRequest.vue?vue&type=template&id=5394f794&scoped=true&"
import script from "./ChangeOfClassRequest.vue?vue&type=script&lang=js&"
export * from "./ChangeOfClassRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394f794",
  null
  
)

export default component.exports